module.exports = __webpack_public_path__ + "img/logo.8d3f981b.svg";